export function getNotificationIcon(reason: string): string {
	switch (reason) {
		case "ORG_CREATED":
			return "mdi mdi-office-building-outline";
		case "INVITATION_SEND":
		case "USER_INVITED":
			return "mdi mdi-email-outline";
		case "USER_REGISTERED":
			return "mdi mdi-account-plus-outline";
		case "USER_ASSIGNED":
			return "mdi mdi-account-group-outline";
		case "DATASET_CREATED":
			return "mdi mdi-database-outline";
		case "ARTIFACT_UPLOADED":
			return "mdi mdi-upload-outline";
		case "ARTIFACT_PROFILING_ERROR":
			return "mdi mdi-alert-outline";
		case "ARTIFACT_PROFILED":
			return "mdi mdi-check-circle-outline";
		case "STREAMING_STATUS_CHANGED":
			return "mdi mdi-chart-line-variant";
		case "DEPARTMENT_CREATED":
			return "mdi mdi-folder-outline";
		case "DATASET_REQUESTED":
			return "mdi mdi-file-question-outline";
		case "DATASET_ACCESS_GRANTED":
			return "mdi mdi-check-decagram-outline";
		case "DATASET_ACCESS_DENIED":
			return "mdi mdi-close-octagon-outline";
		case "SHARING_POLICY_COMPLETED":
			return "mdi mdi-share-variant-outline";
		case "DATASET_PROFILING_ERROR":
			return "mdi mdi-alert-outline";
		case "DATASET_PROFILED":
			return "mdi mdi-check-circle-outline";
		default:
			return "mdi mdi-bell-outline";
	}
}
